"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _Box = _interopRequireDefault(require("../Box"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _OldButton = _interopRequireDefault(require("../OldButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Modal(props) {
  let {
    title,
    back,
    dismiss
  } = props;
  let hasTitleBar = title || back || dismiss; // let distribution = "space-between";
  // if (!dismiss && back) {
  //   distribution = "start";
  // }

  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    style: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      position: "absolute",
      bottom: 0,
      left: 0,
      flex: 1,
      width: "100%",
      height: "100%",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/_react.default.createElement(_reactNative.KeyboardAvoidingView, {
    behavior: _reactNative.Platform.OS == "ios" ? "padding" : "height"
  }, /*#__PURE__*/_react.default.createElement(_reactNative.SafeAreaView, {
    style: {
      backgroundColor: "#fff",
      borderTopRightRadius: 12,
      borderTopLeftRadius: 12
    }
  }, hasTitleBar && /*#__PURE__*/_react.default.createElement(_Stack.default, {
    p: "m",
    distribution: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Box.default, null, back && /*#__PURE__*/_react.default.createElement(_OldButton.default, {
    onPress: back,
    size: "s"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, "\u0628\u0627\u0632\u06AF\u0634\u062A"))), title && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    ff: "mainBold"
  }, title), /*#__PURE__*/_react.default.createElement(_Box.default, null, dismiss && /*#__PURE__*/_react.default.createElement(_OldButton.default, {
    onPress: dismiss,
    size: "s"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, "\u0628\u0633\u062A\u0646")))), /*#__PURE__*/_react.default.createElement(_Box.default, {
    p: "l"
  }, props.children))));
}

var _default = Modal;
exports.default = _default;